import "./Control/Array";
import "./Control/Checkbox";
import "./Control/CheckboxLabel";
import "./Control/Container";
import "./Control/Counter";
import "./Control/DataAutocomplete";
import "./Control/XhrAutocomplete";
import "./Control/Date";
import "./Control/Datepicker";
import "./Control/Datetimepicker";
import "./Control/EnumCheckbox";
import "./Control/EnumRadio";
import "./Control/EnumSelect";
import "./Control/Select";
import "./Control/PopupSelect";
import "./Control/PopupInput";
import "./Control/MultiSelect";
import "./Control/DynDictSelect";
import "./Control/Group";
import "./Control/Label";
import "./Control/ListDataAutocomplete";
import "./Control/ListXhrAutocomplete";
import "./Control/Password";
import "./Control/ServerSourceCheckbox";
import "./Control/Text";
import "./Control/TextArea";
import "./Control/Timepicker";
import "./Control/Colorpicker";
import "./Control/Range";
import "./Control/Point";
import "./Control/File";
import "./Control/Files";
import "./Control/Feature";
import "./Control/FeatureMulti";
import "./Control/Files";
import "./Control/Hidden";
import "./Control/Hr";
import "./Control/ReferenceSelect";
import "./Control/Cadastre";

NS("UI.Widget.Forms");

UI.Widget.Forms.Controls = Class(UI.Widget.Forms.Control.Container, {
    $controls: function(selector) {
        return this.$("control" + selector);
    },

    eachControl: function(callback) {
        this.$("control:not([group]):not([control-bind=manual])").each(function() {
            return callback($(this));
        });
    }
});
